import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createProviderWithCustomFetchData } from './create-data-provider';
import { fetchJsonWithNetworkRetries } from '../utils/fetch';
import { ExperienceMark } from '../utils/experience-tracker';
import { ASSETS_APP_KEY } from '../../constants';
export var APP_SWITCHER_BFF_AVAILABLE_PRODUCTS_ENDPOINT = '/gateway/api/app-switcher/api/available-products';

// TODO: remove this once Asset app becomes standalone app
var transformAppSwitcherBffResponse = function transformAppSwitcherBffResponse(response) {
  if (response.switcherTeam25ExperimentCohort === 'test' && response.assetsAsAnAppEnabled) {
    response.sites.forEach(function (site) {
      if (site.availableProducts.some(function (product) {
        return product.productType === 'JIRA_SERVICE_DESK' && product.isJsmPremium;
      })) {
        site.availableProducts.push({
          productType: ASSETS_APP_KEY
        });
      }
    });
  }
  return response;
};
export var appSwitcherBffAvailableProductsFetch = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var cloudId, product, params, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          cloudId = _ref.cloudId, product = _ref.product;
          params = new URLSearchParams({
            source: 'app-switcher-fe'
          });
          if (cloudId) {
            params.append('tenantid', encodeURIComponent(cloudId));
          }
          if (product) {
            params.append('product', encodeURIComponent(product));
          }
          _context.next = 6;
          return fetchJsonWithNetworkRetries("".concat(APP_SWITCHER_BFF_AVAILABLE_PRODUCTS_ENDPOINT, "?").concat(params.toString()), {
            intervalsMS: [50, 200, 1000]
          }, {
            headers: {
              'Atl-App-Switcher-Private-API': 'true'
            }
          });
        case 6:
          response = _context.sent;
          return _context.abrupt("return", transformAppSwitcherBffResponse(response));
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function appSwitcherBffAvailableProductsFetch(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var createAppSwitcherBffAvailableProductsProvider = function createAppSwitcherBffAvailableProductsProvider() {
  return createProviderWithCustomFetchData('appSwitcherBffAvailableProducts', ExperienceMark.API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, appSwitcherBffAvailableProductsFetch);
};